
define('text!templates/app/member/member.html',[],function () { return '<div id="header" class="tc-row"></div>\n<div id="content" class="page-content"></div>\n';});

